'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('components/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _AddContactForm = require('components/AddContact/AddContactForm/AddContactForm');

var _AddContactForm2 = _interopRequireDefault(_AddContactForm);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var RecipientAddModal = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(RecipientAddModal, _PureComponent);

  function RecipientAddModal() {
    (0, _classCallCheck3.default)(this, RecipientAddModal);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientAddModal.__proto__ || (0, _getPrototypeOf2.default)(RecipientAddModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientAddModal, [{
    key: 'onHide',
    value: function onHide() {
      var onHide = this.props.onHide;

      onHide(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          onSubmit = _props.onSubmit,
          show = _props.show;
      var t = this.context.t;


      return _react2.default.createElement(
        _Modal2.default,
        {
          backdrop: true,
          closeByEsc: true,
          title: t('Enter user name'),
          onHide: this.onHide,
          show: show,
          autoFocus: true
        },
        _react2.default.createElement(_AddContactForm2.default, {
          loading: loading,
          onSubmit: onSubmit
        })
      );
    }
  }]);
  return RecipientAddModal;
}(_react.PureComponent), _class2.propTypes = {
  loading: _propTypes2.default.bool,
  onHide: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  show: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onHide: _noop3.default,
  onSubmit: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onHide'), _class.prototype)), _class);
exports.default = RecipientAddModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddContact/AddContactModal/AddContactModal.js
// module id = 1942
// module chunks = 1